import { ReactElement } from "react";

import { Badge, Text } from "@chakra-ui/react";

import { mobileStyleBreakpoint } from "util/styleHelpers";

const badgeTextStyle = mobileStyleBreakpoint("label", "body2");

const MoreOrdersRequiredBadge = (): ReactElement => (
  <>
    <Badge
      variant="solid"
      px={4}
      py={2}
      borderRadius="36px"
      colorScheme="red"
      bgColor="red.600"
      h="100%"
      textTransform="none"
      textAlign="center"
    >
      <Text textStyle={badgeTextStyle} color="inherit">
        More Orders Required
      </Text>
    </Badge>
  </>
);

export default MoreOrdersRequiredBadge;
